import { render } from "./DistrictInfoComponent.vue?vue&type=template&id=bf3e290c&scoped=true"
import script from "./DistrictInfoComponent.vue?vue&type=script&lang=js"
export * from "./DistrictInfoComponent.vue?vue&type=script&lang=js"

import "./DistrictInfoComponent.vue?vue&type=style&index=0&id=bf3e290c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3e290c"]])

export default __exports__